async function isBrave() {
  if (typeof navigator.brave !== 'undefined') {
    return true;
  }

  if ('navigator' in window && 'permissions' in navigator) {
    const permission = await navigator.permissions.query({
      name: 'notifications'
    });
    return permission.status === 'denied';
  }

  return false;
}

export async function getBrowser() {
  const { userAgent } = navigator;

  if (await isBrave()) {
    return 'Brave';
  }
  if (userAgent.includes('Chrome')) {
    return 'Chrome';
  }
  if (userAgent.includes('Firefox')) {
    return 'Firefox';
  }
  if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari';
  }
  if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  }
  if (userAgent.includes('MSIE') || userAgent.includes('Trident')) {
    return 'Internet Explorer';
  }
  if (userAgent.includes('Edge')) {
    return 'Edge';
  }
  return '';
}
